export const MuiMenuItemNode = {
  styleOverrides: {
    root: {},
  },
};
